import { render, staticRenderFns } from "./ProductAbility.vue?vue&type=template&id=61ef02aa&"
import script from "./ProductAbility.vue?vue&type=script&lang=js&"
export * from "./ProductAbility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports